



















































































import Vue from "vue";
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";
import { Shop, PeopleCounterBlockDef } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";

const db = firebaseProject.firestore();

export default shopBase.extend(Vue).extend({
  name: "PeopleCounterSetting",
  mixins: [form, autoclose],
  data() {
    return {
      parPage: 10,
      currentPage: 1
    };
  },
  computed: {
    collection(): List<PeopleCounterBlockDef> {
      return new Collection(
        db.collection(
          "/shop/" + this.shopId + "/pcounterBlocks"
        ) as firestore.CollectionReference<PeopleCounterBlockDef>
      ).query({
        orderBy: {
          field: "blockId",
          order: "asc"
        }
      });
    },
    listItem(): DocDataRef<PeopleCounterBlockDef>[] | [] {
      const current = this.currentPage * this.parPage;
      const start = current - this.parPage;
      return this.collection?.items
        ? this.collection.items.slice(start, current)
        : [];
    },
    getPageCount(): number {
      return this.collection?.items
        ? Math.ceil(this.collection.items.length / this.parPage)
        : 0;
    },
    total(): number {
      return this.collection.items?.length || 0;
    },
    pageMax(): number {
      const count = this.currentPage * this.parPage;
      const total = this.total || 0;
      return total < count ? total : count;
    }
  },
  async beforeDestroy() {
    await this.shop?.discardWithoutConfirm();
  },
  methods: {
    clickPaginate(pageNum: number) {
      this.currentPage = Number(pageNum);
    },
    async register() {
      if (this.shop?.canSave) {
        const result = await this.shop.save().catch(e => {
          console.log(e);
          alert({
            title: "エラー",
            text: "ピープルカウンター設定の保存に失敗しました。"
          });
        });
        if (result) {
          this.$router.push("/");
        }
      } else {
        alert({
          title: "エラー",
          text: "ピープルカウンター設定が変更されていません。"
        });
      }
    }
  }
});
